<template>
  <!-- File Upload Dialog -->
  <div class="upload-dialog" ref="documentUploadDialog">
    <div class="upload-dialog-content">
      <div class="upload-dialog-title">Upload Lease Document</div>
      <div class="upload-dialog-body">
        <label for="docTitle">Document Title:</label>
        <input id="docTitle" v-model="documentTitle" type="text" />

        <div class="file-upload-zone">
          <input type="file" @change="handleFileUpload" />
          <div
            class="drag-drop-zone"
            @dragover.prevent
            @drop.prevent="handleFileUpload"
          >
            <small>
              Drag and drop PDF here or click to browse. <br />
              You can also email to scan_leases@bigpropertymanagement.com
            </small>
          </div>
        </div>
        <div class="upload-success" v-if="dragSuccessMessage">
          {{ dragSuccessMessage }}
        </div>

        <div class="upload-error">{{ uploadError }}</div>
      </div>
      <div class="upload-dialog-footer">
        <button @click="submitUpload">Upload</button>
        <button @click="closeUploadDialog">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axiosConfig'; // Adjust based on your axios configuration
import eventBus from './eventBus.js';

export default {
  emits: ['closeDocumentUpload'],
  name: 'DocumentUpload',
  data() {
    return {
      showUploadDialog: false,
      documentTitle: '',
      uploadError: '',
      dragSuccessMessage: '', // New property to store success message
    };
  },
  methods: {
    openUploadDialog() {
      this.documentTitle = `lease for ${this.selectedProperty.display}`;
      this.uploadFile = null;
      this.uploadError = '';
      this.dragSuccessMessage = ''; // Reset success message
    },

    handleFileUpload(event) {
      let files = [];

      if (event.target && event.target.files) {
        files = event.target.files;
      } else if (event.dataTransfer && event.dataTransfer.files) {
        files = event.dataTransfer.files;
      }

      if (!files || files.length === 0) {
        this.uploadError = 'No files found in the event.';
        return;
      }

      const file = files[0];
      if (file && file.name.endsWith('.pdf')) {
        this.uploadFile = file;
        this.uploadError = '';
        this.dragSuccessMessage = 'File successfully added!'; // Update success message
      } else {
        this.uploadError = 'Please upload a valid PDF file.';
        this.uploadFile = null;
        this.dragSuccessMessage = ''; // Clear success message if invalid
      }
    },

    async submitUpload() {
      if (!this.uploadFile) {
        this.uploadError = 'No file selected.';
        return;
      }

      if (!this.documentTitle.trim()) {
        this.uploadError = 'Document title must not be blank.';
        return;
      }

      const year = new Date().getFullYear().toString();
      const relativePath = `Cabinet/${year}/Leases`;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadFile);
        formData.append('documentTitle', this.documentTitle);
        formData.append('relativePath', relativePath);

        await axios.post('/api/upload-lease-document', formData);

        // Close the dialog only if post succeeds
        this.closeUploadDialog();
      } catch (error) {
        console.error('Error uploading file:', error);
        this.uploadError = 'Error uploading file.';
      }
    },

    closeUploadDialog() {
      eventBus.emit('closeDocumentUpload');
    },
  },
};
</script>

<style scoped>
/* for file upload dialog */
.upload-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  color: #333;
  padding: 20px;
  box-shadow: 14px 7px 10px 5px rgba(0, 0, 0, 0.25);
  z-index: 1002;
  width: 400px;
  border-radius: 4px;
  border: 1px solid #999;
}

.upload-dialog-content {
  min-height: 200px;
}

.upload-dialog-body {
  margin-top: 8px;
}

.upload-dialog-body label {
  font-weight: bold;
  font-size: 0.9em;
}

.upload-error {
  min-height: 30px;
  text-align: center;
  font-size: 0.9em;
}

.upload-dialog-title {
  margin-top: -20px;
  text-align: center;
  font-size: 1.2em;
  margin-left: -20px;
  margin-right: -20px;
  padding: 8px;
  color: #ddd;
  background: #333;
  margin-bottom: 8px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.upload-dialog input {
  margin-left: 5px;
  padding: 7px;
  border: 1pt solid #ddd;
  border-radius: 4px;
  width: 268px;
}

.upload-dialog-footer button {
  margin-left: 5px;
}

.file-upload-zone {
  margin-top: 10px;
}

.file-upload-zone input {
  width: 382px;
  margin-left: -1px;
}

.drag-drop-zone {
  margin-top: 10px;
  padding: 20px;
  border: 2px dashed #ccc;
  text-align: center;
  cursor: pointer;
}

.upload-error {
  color: red;
  margin-top: 10px;
}

.upload-dialog-footer,
.dialog-buttons {
  text-align: right;
}

.upload-dialog-overlay,
.dialog-overlay,
.edit-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.upload-dialog-footer {
  display: flex;
  justify-content: space-between;
  /* Add any additional styling for footer buttons */
}

.upload-success {
  color: green;
  margin-top: 10px;
  text-align: center;
  font-size: 0.9em;
}
</style>
